import { __assign } from "tslib";
export var fakeSuggestionsResponse = function (_a) {
    var params = _a.params;
    var limit = params.limit;
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                hasMore: false,
                cursor: "xyz-" + Math.random(),
                results: [],
            };
        }
        // eslint-disable-next-line
        var _b = require('@wix/da-sample-data'), deviationsByType_1 = _b.deviationsByType, users_1 = _b.users;
        // eslint-disable-next-line
        var chance_1 = require('chance').Chance();
        var results = Array.from(Array(limit)).map(function (elem, index) {
            return ({
                user: __assign({}, chance_1.pick(users_1)),
                deviations: chance_1.pickset(deviationsByType_1.image, 3),
            });
        });
        return {
            hasMore: true,
            cursor: "xyz-" + Math.random(),
            results: results,
        };
    }
    return { hasMore: false, results: [], cursor: null };
};
export var fakeUnsuggestResponse = function (_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                errorDescription: 'Failed to unsuggest user',
                success: false,
            };
        }
    }
    return { success: true };
};
export var fakeMultiWatchResponse = function (_a) {
    var params = _a.params;
    var usernames = params.usernames;
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                success: usernames.reduce(function (successes, username) {
                    successes[username] = false;
                    return successes;
                }, {}),
                errorDescription: usernames.reduce(function (errors, username) {
                    errors[username] = 'Error watching user';
                    return errors;
                }, {}),
            };
        }
    }
    return {
        success: usernames.reduce(function (successes, username) {
            successes[username] = true;
            return successes;
        }, {}),
    };
};
export var fakeResponse = function (url) { return function (_a) {
    var params = _a.params;
    switch (url) {
        case 'watch/suggestions':
            return fakeSuggestionsResponse({ params: params });
        case 'watch/multi':
            return fakeMultiWatchResponse({ params: params });
        case 'watch/unsuggest':
            return fakeUnsuggestResponse({ params: params });
        default:
            return null;
    }
}; };
//# sourceMappingURL=fakeResponse.js.map